import type { MessageSection } from "./types";

export function reorderSections(sections: MessageSection[], activeId: string, overId: string) {
  const from = sections.findIndex((section) => section.id === activeId);
  const to = sections.findIndex((section) => section.id === overId);
  if (from < 0 || to < 0 || from === to) return sections;
  const reordered = [...sections];
  const [active] = reordered.splice(from, 1);
  if (!active) return sections;
  reordered.splice(to, 0, active);
  return reordered;
}
